type Props = {
  text: string
  percent: number
}

export const ProductEffectItem = ({ text, percent }: Props): JSX.Element => {
  return (
    <div className="flex flex-row justify-between items-center">
      <div className="text-[3.7vw] lg:text-[1.1vw] text-[#666666]">{text}</div>
      <div className="text-[3.7vw] lg:text-[1.1vw] font-bold text-[#999999]">
        <span className="text-[5.3vw] lg:text-[1.6vw] text-[#EB8435]">
          {percent}
        </span>
        %
      </div>
    </div>
  )
}
